import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import 'ag-grid-enterprise';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { SBAMultiSelectCheck, SBADropDown } from "../../UiComponents/SBADropDown";
import { useNavigate, useLocation } from 'react-router-dom';
import "ag-grid-enterprise";
import download from '../../../Images/download.svg';
import { useDispatch, useSelector } from "react-redux";
import {
    getCategory,
    getActivityType,
    getActivityEntityType,
} from "../../actions/investmentAction";
import React, { useEffect, useState, useMemo, useRef } from "react";
import moment from "moment";
import { getAssestListddlAction } from "../../actions/assetsddlAction";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { getMultipleDocs } from "../../actions/assetDocumentsActions";
import { getAssetNoteDetails } from "../../actions/assetNotestabAction";
import { TopBar } from "../../shared/topBar/TopBar";
import { getActivityEntities } from "../../actions/investmentAction";
import { DownloadDocument, DownloadMultiDocument, deleteActivity, getCustomSettings, getActivityEntity, getActivityentityType, getcategory, getTaxEntitiesByContact, getactivityType, getUserPageAccess } from "../../../config/apiConfig";
import { getAllUsers } from "../../actions/UserAction";
import { Splitter } from "@progress/kendo-react-layout";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBNotify } from "../../utils/sbNotify";
import { ToastContainer } from "react-toastify";
import { Modal } from "react-bootstrap";
import { UrlPath } from "../../../config/routeConfig";
import { SBGrid } from "../../UiComponents/SBAAGgrid";
import { getInvestorActivitiesAction } from "../../actions/investorAccounts";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";
import { useCallback } from "react";
import { json } from "d3";
import { Unauthorized } from "../../shared/ErrorPage/ErrorPage";

export const Investor = () => {
    const dispatch = useDispatch();
    const history=useNavigate();
    const Level = [{ BreadCrumb: "Documents > Investor", Routes: "/Documents" }];
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const locationData = useLocation();
    const filterState = sessionStorage?.getItem('investorFilterDetails') ? JSON.parse(sessionStorage.getItem('investorFilterDetails')) : {Category:[],Contact:{EntityId: "-1", EntityName: "Please Select" },Accounts:[],Activity:[],DateRange:[oneMonthAgo.toISOString(), new Date().toISOString()],Subject:null};
    const filter=locationData?.state?.maintainState ? filterState  : {Category:[],Contact:{EntityId: "-1", EntityName: "Please Select" },Accounts:[],Activity:[],DateRange:[oneMonthAgo.toISOString(), new Date().toISOString()],Subject:null};
    const [accountList, setAccountList] = useState([]);
    const [activityList, setActivityList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);

    const [category, setCategory] = useState(filter?.Category || []);
    const [contact, setContact] = useState(filter?.Contact || {EntityId: "-1", EntityName: "Please Select" });
    const [account, setAccount] = useState(filter?.Accounts || []);
    const [activity, setActivity] = useState(filter?.Activity || []);
    const [dateRange, setDateRange] = useState(()=>{
        if (filter && filter?.DateRange && filter?.DateRange?.length === 2) {
            const startDate = new Date(filterState.DateRange[0]);
            const endDate = new Date(filterState.DateRange[1]);
           return [startDate, endDate];
        } else {
          return [oneMonthAgo, new Date()]
        }
       });
    const [investorAccess,setInvestorAccess]=useState(false)
    const [subject, setSubject] = useState(filter?.Subject || null);
    const [resetContainer,setResetContainer]=useState(false);
    const [accessLoading,setAccessLoading]=useState(true);
    
    useEffect(() => {
        document.title='Investor';
        init();
    }, []);
    
    useEffect(() => {
        getAccountByContactID(contact?.EntityId);
    }, [contact]);

    const init =async () => {
        try {
          await  getCategoryList();
          await  getActivityList();
          await  getContactList(0, null, 2);
          await  fetchGridData();
          sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestorAccess` }).then(res=>{setInvestorAccess(res);setAccessLoading(false);});
        } catch (error) {
            setAccessLoading(false);
        }
      
    };
    const getCategoryList = async () => {
        try {
            const response = await sbaAxios({
                url: `${getcategory}${2}`,
                method: 'get',
            });
            setCategoryList(response);
        } catch (error) {
            console.error("Error fetching Category List from API:", error);
        }
    };
    const getActivityList = async () => {
        try {
            const response = await sbaAxios({
                url: `${getactivityType}`,
                method: 'get',
            });
            setActivityList(response);
        } catch (error) {
            console.error("Error fetching Category List from API:", error);
        }
    };
    const getAccountByContactID = async (contactID) => {
        if (contactID > 0) {
            try {
                const response = await sbaAxios({
                    url: `${getTaxEntitiesByContact}${contactID}`,
                    method: 'get',
                });
                const data = response;
                const Entities = data.length>1 ? [{
                    "TaxEntityId": -1,
                    "TaxEntityName": "All"
                }, ...data.sort((a, b) =>
                    a.TaxEntityName.localeCompare(b.TaxEntityName))] : [ ...data.sort((a, b) =>
                        a.TaxEntityName.localeCompare(b.TaxEntityName))];

                const EntityAccount = Entities.map(item => {
                    return {
                        "contactId": item.ContactId,
                        "EntityId": item.TaxEntityId,
                        "EntityName": item.TaxEntityName
                    };
                });
                setAccountList(EntityAccount);
            }

            catch (error) {
                console.error("Error fetching entities from API:", error);
            }

        }
        else {
            try {
                const response = await sbaAxios({
                    url: `${getActivityEntity}ActivityEntityTypeIds=${1}&SearchString=${null}&activitySourceId=2`,
                    method: 'get',
                });
                const data = response;

                const Entities = data.sort((a, b) =>
                    a.EntityName.localeCompare(b.EntityName));
                setAccountList(Entities);

            } catch (error) {
                console.error("Error fetching entities from API:", error);
            }
        }
    };
    const getContactList = async (entityType, searchTerms, sourceid) => {
        try {
            const resposne = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${entityType}&SearchString=${searchTerms}&activitySourceId=${sourceid}`,
                method: 'get',
            });
            const data=[{EntityId: "-1", EntityName: "Please Select" },...resposne];
            setContactList(data);
        } catch (error) {
            return [];
        }
    }
    const handleContactListChange = (e) => {
        if (e) {
            setContact(e.value);
            setAccount([]);
        }
    };
    const handleAccountListChange = (e) => {
        if (e) {
            const currentSelectAll = account?.some((i) => i.EntityName === "All");
            const nextSelectAll = e.value.some((i) => i.EntityName === "All");
            let value = e.value;
            const currentCount = account.length;
            const nextCount = value.length;
            if (
                nextCount > currentCount &&
                !currentSelectAll &&
                !nextSelectAll &&
                accountList.length - 1 === nextCount
            ) {
                value = accountList;
            } else if (
                nextCount < currentCount &&
                currentCount === accountList.length &&
                currentSelectAll &&
                nextSelectAll
            ) {
                value = value.filter((v) => v.EntityName !== "All");
            } else if (!currentSelectAll && nextSelectAll) {
                value = accountList;
            } else if (currentSelectAll && !nextSelectAll) {
                value = [];
            }
            setAccount(value);
        }
    };
    const handleCategoryListChange = (e) => {
        if (e) {
            const currentSelectAll = category.some((i) => i.ActivitySubType.trim() === "All");
            const nextSelectAll = e.value.some((i) => i.ActivitySubType.trim() === "All");
            let value = e.value;
            const currentCount = category.length;
            const nextCount = value.length;

            if (
                nextCount > currentCount &&
                !currentSelectAll &&
                !nextSelectAll &&
                categoryList.length - 1 === nextCount
            ) {
                value = categoryList;
            } else if (
                nextCount < currentCount &&
                currentCount === categoryList.length &&
                currentSelectAll &&
                nextSelectAll
            ) {
                value = value.filter((v) => v.ActivitySubType.trim() !== "All");
            } else if (!currentSelectAll && nextSelectAll) {
                value = categoryList;
            } else if (currentSelectAll && !nextSelectAll) {
                value = [];
            }
            setCategory(value);
        }
    };
    const handleActivityListChange = (e) => {
        if (e) {
            const currentSelectAll = activity.some((i) => i.ActivityType === "All");
            const nextSelectAll = e.value.some((i) => i.ActivityType === "All");
            let value = e.value;
            const currentCount = activity.length;
            const nextCount = value.length;
    
            if (
                nextCount > currentCount &&
                !currentSelectAll &&
                !nextSelectAll &&
                activityList.length - 1 === nextCount
            ) {
                value = activityList;
            } else if (
                nextCount < currentCount &&
                currentCount === activityList.length &&
                currentSelectAll &&
                nextSelectAll
            ) {
                value = value.filter((v) => v.ActivityType !== "All");
            } else if (!currentSelectAll && nextSelectAll) {
                value = activityList;
            } else if (currentSelectAll && !nextSelectAll) {
                value = [];
            }
            setActivity(value);
        }
    };
    const handleDateChange = (e) => {
        if (e.value)
        {
            const newStartDate = e.value.start !== null ? e.value.start : dateRange[0];
            const newEndDate = e.value.end !== null ? e.value.end : dateRange[1];
            setDateRange([newStartDate, newEndDate]);
        }
    };
    const handleSubjectChange = (e) => {
        const updatedText = e.target.value;
        setSubject(updatedText);
    };
    const fetchGridData = () => {
        const localFilters={
            Contact: contact,
            Accounts: account,
            Activity: activity,
            DateRange: dateRange,
            Category: category,
            Subject: subject,
        }
       sessionStorage.setItem('investorFilterDetails',JSON.stringify(localFilters));
        updateActivityStore(contact, account, activity, category, dateRange[0], dateRange[1], subject || null);
    };
    function updateActivityStore(contact, accounts, activities, category, startDateVal, endDateVal, subject) {
        const contactId = contact.EntityId ? contact.EntityId : -1;
        const accountTypeIds = (accounts.length === 0 || accounts.findIndex(item=>item.EntityName==='All')!==-1 ) ? -1 : accounts.map(item => item.EntityId).join(',');
        const activiyTypeIds = (activities.length === 0  || activities.length === activityList.length ) ? -1 : activities.map(item => item.ActivityTypeId).join(',');
        const startDate = startDateVal ? startDateVal.toISOString() : "";
        const endDate = endDateVal ? endDateVal.toISOString() : "";
        const activitySubTypeIds = category.length === categoryList.length ? -1 : category.map(item => item.ActivitySubTypeId).join(',');;
        const sub = subject ? subject : "";
        dispatch(getInvestorActivitiesAction(contactId, accountTypeIds, activiyTypeIds, startDate, endDate, activitySubTypeIds, sub));
    };
    const clearState = () => {
        setResetContainer(val=>!val);
        setContact({ EntityId: "-1", EntityName: "Please Select" });
        setCategory([]);
        setAccount([]);
        setAccount([]);
        setCategory([]);
        setSubject('');
        setActivity([]);
        setDateRange([oneMonthAgo, new Date()]);
    };
    const navigateToEditorAdd=(mode,activityid,currentFilters)=>{
        if (mode === "Add")
            history(`${UrlPath.DocumentInvestorAdd}`,
                {
                    state:
                    {
                        Contact: currentFilters?.Contact,
                        Accounts: currentFilters?.Accounts,
                        Activity: currentFilters?.Activity,
                        DateRange: currentFilters?.DateRange,
                        Category: currentFilters?.Category,
                        Subject: currentFilters?.Subject,
                        from: locationData.pathname,
                    }
                });
        else if (mode === "Edit")
            history(`${UrlPath.DocumentInvestorEdit}${activityid}`,
                {
                    state: {
                        Contact: currentFilters?.Contact,
                        Accounts: currentFilters?.Accounts,
                        Activity: currentFilters?.Activity,
                        DateRange: currentFilters?.DateRange,
                        Category: currentFilters?.Category,
                        Subject: currentFilters?.Subject,
                        from: locationData.pathname,
                    }
                });
    };
    if(!investorAccess)
    {
        return<>
         {!accessLoading ? 
        <> <TopBar label={"Investor"} />
    <div id="assetList" className="mainContentData"><Unauthorized/></div></>:<><LoadingScreen/></>}
        </>
    }
    return <>
        <TopBar label={"Investor"} />
        <div className="mainContentData">
            <BreadCrumbs Levels={Level} />
            <div className="bg-white m-4 mb-3 p-3 border rounded">
                <form >
                    <div className="row border-bottom pb-3">
                        <div className="col-md-3">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Contact
                            </label>
                            <div>
                                <SBADropDown
                                    className="w-75"
                                    textField={"EntityName"}
                                    valueField={"EntityId"}
                                    data={contactList}
                                    value={contact}
                                    onChange={(e) => { handleContactListChange(e) }}
                                />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12 d-block"
                            >
                                Accounts
                            </label>
                            <SBAMultiSelectCheck
                                className="w-75"
                                data={accountList}
                                value={account}
                                filterable={true}
                                textField="EntityName"
                                dataItemKey="EntityId"
                                tags={account.length> 0 ? [{ text: `${account.filter(item => item.EntityName.trim() !== "All").length} items selected`, data: [...account] }] : []}
                                onChange={(e) => { handleAccountListChange(e) }}
                            />
                        </div>
                        <div className="col-md-3">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Activity
                            </label>
                            <div>
                                <SBAMultiSelectCheck
                                    className="w-75"
                                    data={activityList}
                                    value={activity}
                                    dataItemKey="ActivityTypeId"
                                    textField="ActivityType"
                                    onChange={(e) => { handleActivityListChange(e) }}
                                    tags={activity.length > 0 ? 
                                        [{ text: `${activity.filter(item => item.ActivityType.trim() !== "All").length} items selected`, data: [...activity] }]
                                    : []
                                }
                                />
                            </div>
                        </div>
                    </div>
                    <p className="fw-semibold mt-1">Filter by</p>
                    <div className="row" >
                        <div className="col-md-3">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Date Range
                            </label>
                           <div style={{width:"70%"}}>
                            <SBDateRangePicker
                                value={{ start: dateRange[0], end: dateRange[1] }}
                                onChange={(e) => { handleDateChange(e) }}

                            />
                            </div>
                            
                        </div>
                        <div className="col-md-3">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fw-semibold fs-12"
                            >
                                Category
                            </label>
                            <div>
                                <SBAMultiSelectCheck
                                    className="w-75"
                                    data={categoryList}
                                    value={category}
                                    dataItemKey="ActivitySubTypeId"
                                    textField="ActivitySubType"
                                    onChange={(e) => { handleCategoryListChange(e) }}
                                    tags={category.length>0 ? [{ text: `${category.filter(item => item.ActivitySubType?.trim() !== "All").length} items selected`, data: [...category] }] : []}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <label
                                for="select fund"
                                className="mb-1 ms-2 fs-12 fw-semibold"
                            >
                                Subject
                            </label>
                            <input
                                className="w-75 input-default form-control"
                                type="text"
                                placeholder="Type here"
                                onChange={(e) => { handleSubjectChange(e) }}
                                value={subject}
                                onKeyUp={(e) => { if(e.key==='Enter') fetchGridData(); }}
                            />
                        </div>

                    </div>
                    <div className="mt-3">
                        <button
                            type="button"
                            className="enter-btn"
                            onClick={() => { fetchGridData() }}
                        >
                            Enter
                        </button>
                        <button type="button" className="cancel-btn ms-2" onClick={() => { clearState() }}>
                            Clear All
                        </button>
                    </div>
                </form>
            </div>
            <ResultSection reset={resetContainer}   fetchActivties={fetchGridData} navigateToEditorAdd={navigateToEditorAdd}/>
        </div>
        <ToastContainer />
    </>
};
const ResultSection = ({reset ,fetchActivties , navigateToEditorAdd }) => {
    const dispatch = useDispatch();
    // const history = useNavigate();
    const Gstate = useSelector((state) => state) || {};
    const activities = Gstate?.investorAccounts.InvestorActivitiesDetails || [];
    const activitesGridLoading = useSelector((state) => state.investorAccounts.isInvestorActivitiesDetailsLoading);
    const isEditable = Gstate.authorizationData.isEditable;
    const Documents = Gstate.mutipleDocuments.mutipleDocuments || [];
    const DocumentsLoading = Gstate.mutipleDocuments.multipleDocuLoading;

    const documentListRef = useRef();
    const [colDef, setColDef] = useState([]);
    const [investorData, setInvestorData] = useState(activities);
    const [selectedRowDocuList, setSelectedRowDocuList] = useState([]);
    const [showPreview, setShowPreview] = useState();
    const [DocumentCount, setDocumentCount] = useState(0);
    const [showModal,setShowModal]=useState(false);
    const [selectedDocument,setSelectedDocument]=useState(0);
    const [appliedFilter,setAppliedFilter]=useState({});

    const investorSplitterState=localStorage.getItem('DocuInvestorSplitter');
    const [panes, setPanes] = useState(investorSplitterState ? JSON.parse(investorSplitterState) : [{
        size: '70%',
        min: '20px',
        collapsible: true
    }, {}, {
        size: '20%',
        min: '20px',
        collapsible: true
    }]);
    const [clientReportingEdit,setClientReportingEdit]=useState(false);
    const getAccessForEdit = async () => {
        try {
            const response = await sbaAxios({ url:  `${getUserPageAccess}?keyName=ClientReportingEditAccess` });
            setClientReportingEdit(response);       
            fetchGridData();   
            fetchActivties();  
        } catch (error) {
            setClientReportingEdit(false);       
            fetchGridData();   
            fetchActivties();  
        }
    };
    useEffect(() => { 
      
        getAccessForEdit();
       
     }, []);
    useEffect(() => {
        setInvestorData(activities);
        setShowPreview(false);
    }, [activities]);
    useEffect(() => {
        setSelectedRowDocuList(Documents);
    }, [Documents]);
    useEffect(()=>{
        setInvestorData([]);
        setShowPreview(false);
    },[reset])
    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };
    const isRowSelectable = useMemo(() => {
        return (params) => {
            return true;
        };
    }, []);
    const handleLinkClick = (row) => {
        setDocumentCount();
        const ActivityId = row.data.ActivityId;
        if (ActivityId != 0) {
            dispatch(getMultipleDocs(ActivityId));
        }
        dispatch(getAssetNoteDetails(ActivityId));
        
        setShowPreview(true);
       
       
    };
    const defaultColDef = useMemo(() => { 
        return {
            sortable: true,
            resizable:true,
            minWidth:100,
            filter: 'agTextColumnFilter',
            autoHeaderHeight: true,
            floatingFilter: true,
        };
    }, []);
    const handleRowDoubleClicked = () => {
        try {
            const documentId = Documents[0].DocumentId;
            const documentName = Documents[0].DocumentName;

            sbaAxios({
                 url: DownloadDocument + documentId,
                 responseType: "blob",
            }).then((response) => {
                const blobUrl = URL.createObjectURL(response);
                const newWindow = window.open(blobUrl, '_blank');
                URL.revokeObjectURL(blobUrl);
             });
          
            
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };
    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}1013` });
            
            const ClientReportingEditAccess = await sbaAxios({ url:  `${getUserPageAccess}?keyName=ClientReportingEditAccess` });
            if (response) {
                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const filterOptions = response.CustomFilterValue.trim() !== "" ? JSON.parse(response.CustomFilterValue) : null;
                const isProcessedIndex = apiColDef.findIndex((item) => item.colId === "IsProcessed");
                console.log('column defs: ', apiColDef);

            if (isProcessedIndex === -1) {
                // Add the column if it doesn't exist
                const isProcessedColumn = {
                    colId: "IsProcessed",
                    width: 100,
                    headerName: "Is Processed",
                    hide: false,
                    pinned: null,
                    sort: null,
                    sortIndex: null,
                    aggFunc: null,
                    rowGroup: false,
                    rowGroupIndex: null,
                    pivot: false,
                    pivotIndex: null,
                    flex: 1
                };

                const insertIndex = apiColDef.length > 0 ? apiColDef.length - 2 : 0;
                apiColDef.splice(insertIndex, 0, isProcessedColumn);

            } else if (isProcessedIndex === apiColDef.length - 1) {
                // Move it one index before the last index if it is at the end
                const [isProcessedColumn] = apiColDef.splice(isProcessedIndex, 1);
                apiColDef.splice(apiColDef.length - 2, 0, isProcessedColumn);
            }
            const createdByIndex = apiColDef.findIndex(col => col.colId === "CreatedByName");


                if (createdByIndex === -1) {
                    // Define the Created By column
                    console.log("cant find created by column. creating created by column")
                    const createdByColumn = {
                        colId: "CreatedByName",
                        width: 120,
                        headerName: "Created By",
                        hide: false,
                        pinned: null,
                        sort: null,
                        sortIndex: null,
                        aggFunc: null,
                        rowGroup: false,
                        rowGroupIndex: null,
                        pivot: false,
                        pivotIndex: null,
                        flex: 1
                    };

                    // Insert Created By column right after IsProcessed column
                    apiColDef.splice(isProcessedIndex + 1, 0, createdByColumn);
                }
                const filterdColumnDef = apiColDef.filter(item => !/_\d+$/.test(item.colId));
                const formattedDef = filterdColumnDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    maxWidth:item.colId === "DocumentStatusName" ? 100 :null,
                    cellRenderer: item.colId === "Action" ? (e)=>ActionsRenderer(e,initiateDetailsdelete,onEditButtonClick,ClientReportingEditAccess) : item.colId === "IsMarketCommentary" ? checkBoxFormatter : item.colId === "IsQuarterlyLetter" ? checkBoxFormatter : item.colId === "ActivityDate" ? valuformaterapply : item.colId === "CreatedDate" ? valuformaterapply : item.colId === "EntityTypeId" ? entityTypeRenderer :item.colId === "IsProcessed" ? 'agCheckboxCellRenderer': null,
                    "headerName": item.colId === "ActivityDate" ? "Document Date" : item.colId === "ActivitySubType" ? "Document Type" : item.colId === "ActivityName" ? "Subject" : item.colId === "DocumentStatusName" ? "Status" : item.colId === "CreatedByName"?"Created By": null,
                    "tooltipField": item.colId === "EntityTypeName" ? "EntityTypeName" : item.colId === "EntityName" ? "EntityName" :
                        item.colId === "ActivityType" ? "ActivityType" : item.colId === "ActivitySubType" ? "ActivitySubType" :
                        item.colId === "DocumentName" ? "DocumentName" : item.colId === "ActivityName" ? "ActivityName" :null ,
                    floatingFilter: item.colId === "Action" ? false : true,
                    
                }));
                return { columns: formattedDef, filters: filterOptions };
            }
        } catch (error) {
            console.log(error);
            return { columns: [], filters: {} };
        }
    };
    const handleSplitterChange = event => {
        localStorage.setItem("DocuInvestorSplitter",JSON.stringify(event.newState));
        setPanes(event.newState);
    };
    const downloadRowDocuments = () => {
        const selectedNodes = documentListRef.current.api.getSelectedNodes();
        if (selectedNodes.length > 0) {
            const documentIDs = selectedRowDocuList.map(item => item.DocumentId).join(',') || null;
            if (documentIDs !== null) {
                try {
                    const downloadUrl = `${DownloadMultiDocument}${documentIDs}`;
                    sbaAxios({ url: downloadUrl, responseType: 'blob' }).then((response) => {
                        window.open(URL.createObjectURL(response, "_blank"));
                    });
                } catch (error) {
                    console.error('Error downloading documents:', error);

                }
            }
        }
    };
  
    const initiateDetailsdelete = (e) => {
        if (e.data) {
            const ActivityID = e.data.ActivityId;
            setSelectedDocument(ActivityID);
            setShowModal(true);
        }
    };
    const onEditButtonClick = (e,appliedFilter) =>  {
        const activityid = e.data.ActivityId;
        navigateToEditorAdd("Edit", activityid , appliedFilter);
    };
  

    const checkBoxFormatter = (params) => {
        return <input type='checkbox' checked={params.value === true} disabled />;
    };
    const valuformaterapply = (params) => {
        return moment(params.value).format("MM/DD/YYYY");
    };
    function getFilenameWithoutExtension(filename) {
        return filename.split('.').slice(0, -1).join('.');
      }
    const Preview = ({docCount}) => {
        const pdfview = (documentId, documentExtension, documentName) => {
            try {
                documentExtension=documentExtension.toLowerCase();
                if (
                    documentExtension === ".pdf" ||
                    documentExtension === ".xlsx" ||
                    documentExtension === ".xls" ||
                   documentExtension === ".png" ||
                    documentExtension === ".jpg" ||
                    documentExtension === ".jpeg" ||
                    documentExtension === ".gif" ||
                    documentExtension === ".doc" ||
                    documentExtension === ".docx" || 
                    documentExtension === ".ppt" || 
                    documentExtension === ".pptx" ||
                    documentExtension === ".msg" ||
                    documentExtension === "pdf" ||
                    documentExtension === "xlsx" ||
                    documentExtension === "xls" ||
                    documentExtension === "png" ||
                    documentExtension === "jpg" ||
                    documentExtension === "msg" ||
                    documentExtension === "jpeg" ||
                    documentExtension === "gif" ||
                    documentExtension === "doc" ||
                    documentExtension === "docx" || 
                    documentExtension === "ppt" || 
                    documentExtension === "pptx"
                ) {
                   
                    const encodedDocumentId = btoa(documentId.toString());
                    const urls = DownloadDocument + encodedDocumentId;
                    sbaAxios({
                         url: urls,
                    //     responseType: 'blob'
                     }).then((response) => {
                        window.open(urls);
                  
                 });
                } else {
                    const nameWithoutExtension = getFilenameWithoutExtension(documentName);
                    const encodedDocumentId = btoa(documentId.toString());
                    const urls = DownloadDocument + encodedDocumentId;
                    sbaAxios({
                         url: urls,
                         responseType: 'blob'
                     }).then((response) => {
                        const blob = new Blob([response]);
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `${nameWithoutExtension}.${documentExtension}` 
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                  
                 });
                }
            } catch (error) {
                console.error("Error opening document:", error);
            }
        };

        const noteDetails = useSelector(
            (state) => state.notesTabDetails.noteDetails
        );
        const noteDate = moment(noteDetails?.ActivityDate).format("MM-DD-YYYY");
        if (activities.length > 0) {
            if (Documents.length > 0 || noteDetails != null) {
                return (
                    <div id="InvestmentId">
                        {DocumentsLoading ? <><LoadingScreen /></> :
                            showPreview && <>
                                <div class="attachments bg-white p-3 mt-3">

                                    <form >
                                        <ul class="list-unstyled m-0">
                                            <li class="fw-medium mb-3">
                                                Attachment{" "}
                                                <span class="notify ms-2">
                                                    {Documents.length >0?Documents.length : 0}
                                                </span>
                                            </li>
                                        </ul>
                                    </form>

                                    {Documents?.length === 0 ? (
                                        <label>No Documents Available </label>
                                    ) : (
                                        Documents?.map((item) => {
                                            item.DocumentExtension  = item.DocumentExtension.toLowerCase();
                                            return (
                                                <div class="card-body p-0">
                                                    <div class="row p-3 border-bottom  m-0">
                                                        <div class="col-11 left">
                                                            <span>{item.DocumentName}</span>
                                                        </div>
                                                        {
                                                            <div class="col-1 text-sm-end fw-medium">
                                                                <span className="SBA_hand">
                                                                    {item.DocumentExtension === ".pdf" || item.DocumentExtension === "pdf" ? (
                                                                        <i
                                                                            class="fas fa-file-pdf"
                                                                            style={{ color: "#F40F02" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension,
                                                                                    item.DocumentName
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    ) : item.DocumentExtension === ".xlsx" ||
                                                                        item.DocumentExtension === ".xls" || 
                                                                        item.DocumentExtension === "xlsx" ||
                                                                        item.DocumentExtension === "xls" ? (
                                                                        <i
                                                                            class="fas fa-file-excel"
                                                                            style={{ color: "#1D6F42" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    ) : item.DocumentExtension === ".png" ||
                                                                        item.DocumentExtension === ".jpg" ||
                                                                        item.DocumentExtension === ".jpeg" ||
                                                                        item.DocumentExtension === ".gif" ||
                                                                        item.DocumentExtension === "png" ||
                                                                        item.DocumentExtension === "jpg" ||
                                                                        item.DocumentExtension === "jpeg" ||
                                                                        item.DocumentExtension === "gif" ? (
                                                                        <i
                                                                            class="fas fa-file-image"
                                                                            style={{ color: "#1E3050" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension
                                                                                )
                                                                            }
                                                                        ></i>
                                                                    ) :
                                                                        item.DocumentExtension === ".doc" ||
                                                                            item.DocumentExtension === ".docx" ||
                                                                            item.DocumentExtension === "doc" ||
                                                                            item.DocumentExtension === "docx" ? (
                                                                            <i
                                                                                class="fas fa-file-word"
                                                                                style={{ color: "#2284D9" }}
                                                                                onClick={() =>
                                                                                    pdfview(
                                                                                        item.DocumentId,
                                                                                        item.DocumentExtension
                                                                                    )
                                                                                }
                                                                            ></i>
                                                                        ) : item.DocumentExtension === ".ppt" ||
                                                                            item.DocumentExtension === ".pptx" || 
                                                                            item.DocumentExtension === "ppt" ||
                                                                            item.DocumentExtension === "pptx" ? (
                                                                            <i
                                                                                class="fas fa-file-powerpoint"
                                                                                style={{ color: "#C13B1B" }}
                                                                                onClick={() =>
                                                                                    pdfview(
                                                                                        item.DocumentId,
                                                                                        item.DocumentExtension
                                                                                    )
                                                                                }
                                                                            ></i>
                                                                        ) : (
                                                                            <i
                                                                            class="fa-solid fa-file"
                                                                            style={{ color: "#C13B1B" }}
                                                                            onClick={() =>
                                                                                pdfview(
                                                                                    item.DocumentId,
                                                                                    item.DocumentExtension,
                                                                                    item.DocumentName
                                                                                )
                                                                            }
                                                                        ></i>
                                                                        )}
                                                                </span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                                <div className="col-sm-12" style={{ height: "16px" }}></div>
                                <div class="investors bg-white p-3">
                                    <div className="row my-2 mt-4">
                                        {/*<div className="col-md-4">*/}
                                        {/*    <div className="fw-medium">Owner :</div>*/}
                                        {/*    <div className="fw-medium">{noteDetails?.ActivitySource}</div>*/}
                                        {/*</div>*/}
                                        <div className="col-md-4">
                                            <div className="fw-medium">Created By :</div>
                                            <div className="fw-medium">{noteDetails?.ActivitySource}</div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="fw-medium">Document Date :</div>
                                            <div className="fw-medium">{noteDate}</div>
                                        </div>
                                    </div>
                                    <div className="fw-medium">Subject :</div>
                                    <div className="fw-medium mb-2">{noteDetails?.ActivityName}</div>
                                    <div className="fw-medium ">Body :</div>
                                    <div >
                                        <iframe
                                            title="my-iframe"
                                            width="100%"
                                            height="400px"
                                            src={decodeHTMLEntities(noteDetails?.ActivityDescriptionHTML)}
                                        ></iframe>
                                    </div>
                                </div></>}
                    </div>
                );
            }
        }
    };
    const decodeHTMLEntities = (encodedString) => {
        const encodedHtmlContent = encodeURIComponent(encodedString);
        const src = `data:text/html;charset=utf-8,${encodedHtmlContent}`;
        if (encodedString == undefined)
            return "";
        return src;
    };
    const entityTypeRenderer = (params) => {
        if (params.value === 0)
            return 'Contact';
        else if (params.value === 1)
            return 'Account';
        else
            return '';
    };
    const deleteSelectedDetails = () => {
        sbaAxios({ url: `${deleteActivity}${selectedDocument}` }).then(res => {
            SBNotify({ Msg: "Selected Document Deleted Successfully", type: "success" });
            setShowModal(false);
            setShowPreview(false);
            fetchActivties();
        }).catch(error => {
            SBNotify({ Msg: error, type: "error" });
            setShowModal(false)
        })
    };
    const onAddButtonClick = useCallback((e) => {
        navigateToEditorAdd("Add", 0 , appliedFilter);
    },[appliedFilter]);

    return <>
        <div className="mx-4 p-3">
            <div className="row">
                <Splitter orientation={'vertical'}>
                    <Splitter panes={panes} onChange={(e) => { handleSplitterChange(e) }}>
                        <div className="col-lg-12 col-md-12 bg-white  rounded">
                            <div className="mt-3 d-flex justify-content-between" style={{ marginTop: "20px" }}>
                                <p className="fw-semibold p-0 py-1">List of Details</p>
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="submit" onClick={(e)=>{onAddButtonClick(e)}} className="p-sm-btn mx-1" disabled={!isEditable}><i className="fa-solid fa-plus" /> Add</button>
                                    <button type="button" className="p-sm-btn mx-1" onClick={() => { downloadRowDocuments() }}><img src={download} alt="" />Download</button>
                                </div>
                            </div>
                            <>
                          
                            <SBGrid ref={documentListRef} isLoading={activitesGridLoading} defaultColDef={defaultColDef} column={colDef} row={investorData} pageSize={15} rowSelection="single" filters={appliedFilter} componentID={1013} gridStyle={{ width: '100%', height: '75vh' }} isRowSelectable={isRowSelectable} onRowClicked={handleLinkClick} onRowDoubleClicked={handleRowDoubleClicked}></SBGrid>

                            </>
                        </div>
                        <div class="col-lg-12 mt-md-2 mt-lg-0">
                            <div className="preview">
                                <p className="fw-semibold py-3 px-3">Preview</p>
                                <Preview docCount={DocumentCount}/>
                            </div>
                        </div>
                    </Splitter>
                </Splitter>
            </div>
        </div>
        <Modal show={showModal}  >
                <Modal.Header closeButton onClick={() => { setShowModal(false) }}>
                    <Modal.Title>Do you want to delete the selected Document?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Document will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={() => { setShowModal(false) }}>Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={() => { deleteSelectedDetails() }} >
                        Yes
                    </button>
                </Modal.Footer>
            </Modal>
    </>
};

const ActionsRenderer = (event,initiateDetailsdelete,onEditButtonClick,ClientReportingEditAccess) => {
    const isEditable = useSelector(state => state.authorizationData.isEditable);
    // const activities = Gstate?.investorAccounts.InvestorActivitiesDetails || [];

    const [isEdit, setIsEdit] = useState(isEditable);
    // const [clientReportingEditAccess,setClientReportingEditAccess]=useState(true);
   
    useEffect(() => { setIsEdit(isEditable) }, [isEditable]);
    // useEffect(() => { setClientReportingEditAccess(clientReportingEdit) }, [clientReportingEdit]);
    // console.log(clientReportingEdit,'clientReportingEdit')
    // console.log(clientReportingEditAccess,'clientReportingEditAccess')
    if(event.data.ActivitySubType === 'Client Reporting' )
    return (<>
    <div className="actions-cell">
            <i onClick={(e) => { ClientReportingEditAccess && onEditButtonClick(event) }}
                className="fas fa-edit" style={{ color: ClientReportingEditAccess === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}></i>

            <i onClick={(e) => { ClientReportingEditAccess && initiateDetailsdelete(event) }}
                className="fa fa-trash"
                style={{ color: ClientReportingEditAccess === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }}
            ></i>
        </div>
    </>)
    else 
    return (
        <div className="actions-cell">
            <i onClick={(e) => { isEdit && onEditButtonClick(event) }}
                className="fas fa-edit" style={{ color: isEdit === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }}></i>

            <i onClick={(e) => { isEdit && initiateDetailsdelete(event) }}
                className="fa fa-trash"
                style={{ color: isEdit === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }}
            ></i>
        </div>
    );
};